import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import {
  BLACK,
  GRAY_DARK,
  GRAY_DARKEST,
  GREEN,
  RED,
  YELLOW
} from "../../../../constants";

import AdhocProjectsTableHeader from "./Header";
import { AdhocProject } from "integrity-owls-logic/dist/models/AdhocProjects";

const useStyles = makeStyles(theme => ({
  approvedStatusText: {
    color: GREEN
  },
  buttonSpan: {
    "&:hover": {
      cursor: "pointer"
    },
    padding: "10px",
    fontWeight: "bold"
  },
  pendingStatusText: {
    color: YELLOW
  },
  deniedStatusText: {
    color: RED
  },
  paper: {
    backgroundColor: "transparent",
    width: "100%",
    marginBottom: theme.spacing(2),
    boxShadow: "none"
  },
  table: {
    minWidth: 750
  },
  tableCell: {
    backgroundColor: GRAY_DARKEST,
    border: "none",
    borderBottom: "10px solid " + BLACK
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer"
    }
  },
  tableWrapper: {
    overflowX: "auto"
  },
  workIdText: {
    paddingLeft: "20px",
    fontSize: "20px",
    color: GRAY_DARK,
    fontStyle: "italic"
  }
}));

interface AdhocProjectsTableProps {
  handleToggleStatus: (project: AdhocProject) => void;
  projects: AdhocProject[];
  loading: boolean;
}

const NoResultsRow = () => {
  return (
    <TableRow tabIndex={-1}>
      <TableCell align="center">No Results</TableCell>
    </TableRow>
  );
};

export const AdhocProjectsTable: React.FC<AdhocProjectsTableProps> = ({
  handleToggleStatus,
  projects,
  loading
}) => {
  const classes = useStyles();

  const renderActionButton = (project: AdhocProject) => {
    let buttonText = "";
    let backgroundColor = "";
    project.active ? (buttonText = "Deactivate") : (buttonText = "Activate");
    project.active ? (backgroundColor = RED) : (backgroundColor = GREEN);

    return (
      <Button
        variant="contained"
        style={{ backgroundColor }}
        onClick={() => handleToggleStatus(project)}
        size="small"
      >
        {buttonText}
      </Button>
    );
  };

  const renderTableBody = () => {
    if (loading) {
      const rows = [];
      rows.push(
        <TableRow className={classes.tableRow}>
          <TableCell colSpan={5} align="center">
            <CircularProgress />
          </TableCell>
        </TableRow>
      );
      for (let i = 0; i < projects.length - 1; i++) {
        rows.push(
          <TableRow className={classes.tableRow}>
            <TableCell colSpan={5} align="center"></TableCell>
          </TableRow>
        );
      }
      return <TableBody>{rows}</TableBody>;
    }
    if (projects.length < 1) {
      return <NoResultsRow />;
    }
    return (
      <TableBody>
        {projects.map(project => {
          return (
            <TableRow
              tabIndex={-1}
              key={project.id}
              className={classes.tableRow}
            >
              <TableCell className={classes.tableCell} align="left">
                {project.id}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {project.name}
              </TableCell>
              <TableCell
                className={classes.tableCell}
                style={{ color: project.active ? GREEN : RED }}
                align="left"
              >
                {project.active ? "Active" : "Inactive"}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {renderActionButton(project)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  return (
    <Paper className={classes.paper}>
      <div className={classes.tableWrapper}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <h2>Agreements</h2>
        </Box>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size="small"
          aria-label="enhanced table"
        >
          <AdhocProjectsTableHeader />
          {renderTableBody()}
        </Table>
      </div>
    </Paper>
  );
};
